import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isAuthed = await auth.isAuthenticated();
  if (isAuthed) return true;

  const returnUrl = state.url || '/home';

  // Store returnUrl in sessionStorage
  sessionStorage.setItem('auth_returnUrl', returnUrl);

  return router.createUrlTree(['/login'], { queryParams: { returnUrl, error: 'unauthenticated' } });
};
